import React from 'react';

/**
 * The Campuzon mark. Two authored lockups exist and neither is a scaled
 * version of the other, so the variant is chosen by the space available
 * rather than by resizing one of them.
 */
const INLINE = 'https://cdn.magicpatterns.com/uploads/biQbP8deTREVjPUnRwr8hE/In-Line.png';
const STACKED = 'https://cdn.magicpatterns.com/uploads/5X4cUgWcmFzHY75rMeYxWN/Be-Neath.png';
interface LogoProps {
  /** Shown under the lockup — usually which console you are in. */
  subtitle?: string;
  variant?: 'inline' | 'stacked';
  /** Height of the lockup in pixels. Width follows the artwork. */
  height?: number;
  className?: string;
}
export function Logo({
  subtitle,
  variant = 'inline',
  height,
  className
}: LogoProps) {
  const stacked = variant === 'stacked';
  return <div className={`min-w-0 ${stacked ? 'text-center' : ''} ${className ?? ''}`} data-id="element-5197" data-mp="1lupm2dm2i64l">
      <img src={stacked ? STACKED : INLINE} alt="Campuzon" style={{
      height: height ?? (stacked ? 88 : 26)
    }} className={`w-auto max-w-full ${stacked ? 'mx-auto' : ''}`} data-id="element-5198" data-mp="1lslijws2z94u" />
      {subtitle && <p className={`mt-1.5 truncate text-caption text-ink-subtle ${stacked ? '' : 'pl-0.5'}`} data-id="element-5199" data-mp="pc5sln01q79c">
          {subtitle}
        </p>}
    </div>;
}